export const getSubscriptionPaymentId = (payment) => {
  if (!payment) return '';
  const paymentId = payment.id || payment._id || payment.transactionId || payment.reference;
  return paymentId ? String(paymentId) : '';
};

const getSubscriptionSchoolId = (user) => {
  const school = user?.school;
  if (!school) return '';
  const schoolId = school._id || school.id || school;
  return schoolId ? String(schoolId) : '';
};

const getSubscriptionPaymentAckKey = (payment, user) => {
  const paymentId = getSubscriptionPaymentId(payment);
  if (!paymentId) return '';
  const schoolId = getSubscriptionSchoolId(user) || 'school';
  const adminId = user?._id || user?.id || 'admin';
  return `subscriptionPaymentAcknowledged:${schoolId}:${adminId}:${paymentId}`;
};

export const hasAcknowledgedSubscriptionPayment = (payment, user) => {
  const paymentId = getSubscriptionPaymentId(payment);
  const ackKey = getSubscriptionPaymentAckKey(payment, user);
  if (!paymentId || !ackKey) return true;

  try {
    return (
      localStorage.getItem(ackKey) === 'true'
      || sessionStorage.getItem(ackKey) === 'true'
      || localStorage.getItem(`subscriptionPaymentAcknowledged:${getSubscriptionSchoolId(user) || 'school'}:${paymentId}`) === 'true'
      || localStorage.getItem('lastAcknowledgedPaymentId') === paymentId
    );
  } catch (error) {
    return false;
  }
};

export const acknowledgeSubscriptionPayment = (payment, user) => {
  const paymentId = getSubscriptionPaymentId(payment);
  const ackKey = getSubscriptionPaymentAckKey(payment, user);
  if (!paymentId || !ackKey) return;

  try {
    localStorage.setItem(ackKey, 'true');
    sessionStorage.setItem(ackKey, 'true');
  } catch (error) {
    try { sessionStorage.setItem(ackKey, 'true'); } catch { /* Server acknowledgement remains authoritative. */ }
  }
};

